
import { defineComponent } from "vue";

export default defineComponent({
  name: "bucket-total",
  props: {
    total: Number,
    completed: Number,
    remaining: Number,
  },
});
